import src from "IMAGE";
export default { src, width: 351, height: 259, blurWidth: 0, blurHeight: 0};
